import LayerComponent, { Layer } from './Layer';
export { Layer };
export default LayerComponent;
